var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "standard_header",
      class: [_vm.type, _vm.header_type],
      style: {
        "--content-bg-pos": _vm.image_position,
        "--quick-links-height":
          _vm.quick_links_height - (_vm.window.width < 1280 ? 30 : 0) + "px",
        "--quick-links-height-neg": "-" + 61 + "px",
      },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            {
              staticClass: "text",
              class: [
                { "no-image": !_vm.parsedImage },
                _vm.type,
                _vm.header_type,
              ],
            },
            [
              _vm._t("breadcrumbs"),
              _vm._v(" "),
              _c("div", { staticClass: "inner" }, [
                _vm.title
                  ? _c("h1", {
                      class: [_vm.type, _vm.header_type],
                      attrs: {
                        "data-highlightword": _vm.getWordsInFirstRow(_vm.title),
                      },
                      domProps: { innerHTML: _vm._s(_vm.title) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.description
                  ? _c("div", {
                      staticClass: "body",
                      class: [_vm.type, _vm.header_type],
                      domProps: { innerHTML: _vm._s(_vm.description) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.parsedCta
                  ? _c(
                      "div",
                      { staticClass: "cta_container" },
                      [
                        _c("secondary-button", {
                          attrs: {
                            label: _vm.parsedCta.title,
                            link: _vm.parsedCta,
                            theme: "reverse",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm.header_type != "slim"
            ? _c(
                "div",
                {
                  staticClass: "image",
                  class: [
                    { "no-image": !_vm.parsedImage },
                    _vm.type,
                    _vm.header_type,
                  ],
                  style: {
                    "--image-mask": "url(" + _vm.imageMask + ")",
                    "--image-mask-mobile": "url(" + _vm.imageMaskMobile + ")",
                    "--no-image-mask": "url(" + _vm.imageNoImageMask + ")",
                  },
                },
                [
                  _vm.parsedImage
                    ? _c("img", {
                        class: _vm.type,
                        attrs: { src: _vm.parsedImage.url, alt: _vm.title },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }